import axios from "axios"
import { API_URL_ESPACE_AVENTURIER } from "../../constants"

export function ignoreTutorialRequest() {
     return axios.post(`${API_URL_ESPACE_AVENTURIER}/ignore-tutorial`, {})
}
